// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__hE8tH","footer":"ModalInfo_footer__W2ZlL"};